import Typography from '@components/v2/ui/Typography/Typography';
import { Box, LinearProgress } from '@mui/material';
import { Fragment } from 'react';
import LangEnum from '../../../../../lang/LangEnum';
import { TargetStatus, TargetUnit } from '../../../../../services/modules/target/target.types';
import TargetConversionCell from '../../../../target/components/TargetConversionCell/TargetConversionCell';
import { OrderTargetBreakdown, OrderTargetBreakdownListRow } from '../../orderTargets.types';
import OrderTargetsLoadError from '../OrderTargetsLoadError';
import useOrderTargetBreakdownListStyles from './orderTargetBreakdownList.styles';

interface OrderTargetBreakdownListProps {
  rows: OrderTargetBreakdownListRow[];
  unit: TargetUnit;
  targetStatus: TargetStatus;
  breakdown: Pick<OrderTargetBreakdown, 'isLoading' | 'isError' | 'reload'>;
}

const OrderTargetBreakdownList = ({
  rows,
  unit,
  targetStatus,
  breakdown,
}: OrderTargetBreakdownListProps) => {
  const { classes } = useOrderTargetBreakdownListStyles();

  if (breakdown.isError) {
    return (
      <OrderTargetsLoadError
        message={LangEnum.TARGET_OBJECT_ITEMS_ERROR}
        onRetry={breakdown.reload}
      />
    );
  }

  if (breakdown.isLoading) {
    return (
      <Box className={classes.loading}>
        <LinearProgress />
      </Box>
    );
  }

  if (rows.length === 0) {
    return null;
  }

  return (
    <Box className={classes.list}>
      {rows.map((row) => (
        <Fragment key={row.id}>
          <Typography variant="body2" color="textSecondary" noWrap>
            {row.label}
          </Typography>
          <Typography variant="body2" color="textSecondary" className={classes.amounts}>
            {row.amountsLabel}
          </Typography>
          <Box className={classes.conversion}>
            <TargetConversionCell
              attainment={row.attainment}
              unit={unit}
              targetStatus={targetStatus}
              labelPosition="left"
              labelColor="text.secondary"
              labelVariant="body2"
            />
          </Box>
        </Fragment>
      ))}
    </Box>
  );
};

export default OrderTargetBreakdownList;
